import { useQuery, useQueryClient } from "@tanstack/react-query";
import { WarehouseCheckInService } from "src/services";
import { QueryParamsMapper } from "src/mappers";
import { queryKeys } from "src/constants";
import { DateTimeRange, WarehouseCheckInsPaginationOptions, WarehouseCheckInsFilters } from "src/types";

const useWarehouseCheckIns = (
  warehouseCheckInService: WarehouseCheckInService,
  dateTimeRange?: DateTimeRange,
  filter?: WarehouseCheckInsFilters,
  paginationOptions?: WarehouseCheckInsPaginationOptions
) => {
  const queryClient = useQueryClient();

  const queryParams = QueryParamsMapper.getWarehouseCheckInsQueryParams(dateTimeRange, filter, paginationOptions);

  const {
    data: paginatedWarehouseCheckIns,
    error: fetchError,
    isLoading
  } = useQuery({
    queryKey: queryKeys.paginatedWarehouseCheckIns(queryParams),
    queryFn: () => warehouseCheckInService.getWarehouseCheckIns(queryParams)
  });

  const refreshWarehouseCheckIns = () => {
    queryClient.removeQueries({
      queryKey: queryKeys.paginatedWarehouseCheckIns(),
      exact: false
    });
  };

  return { paginatedWarehouseCheckIns, fetchError, isLoading, refreshWarehouseCheckIns };
};

export { useWarehouseCheckIns };
